import {ActionType} from "../../model/actionTypes";
import {errorHandler} from "./auth";

export const getUsage =  (paramsObj: any) => async (dispatch: Function, getState: Function, api: any) => {
    dispatch({type: ActionType.LOADER, payload: true});
    try {
        const params = JSON.stringify(paramsObj);
        const response = await api.get(`report/getOdUserApiUsage?params=`+params);
        dispatch({type: ActionType.LOADER, payload: false});
        return response;
    } catch (err) {
        dispatch({type: ActionType.LOADER, payload: false});
        dispatch(errorHandler(err))
        return [];
    }
}

export const updateApiUsageLogs = (data: any) => async (dispatch: Function, getState: Function, api: any) => {
    dispatch({type: ActionType.LOADER, payload: true});
    try {
        const response = await api.put(`report/updateApiUsageLogs`, data);
        dispatch({type: ActionType.LOADER, payload: false});
        return response;
    } catch (err) {
        dispatch({type: ActionType.LOADER, payload: false});
        dispatch(errorHandler(err))
        return [];
    }
}

